// For the moment the cost of loading all 3 configs, is
// less than the time delay of loading one serially during
// startup. Also consider that TKO has all 3 in its constants
import dev from '@/config/config.dev.json';
import us from '@/config/config.us.json';
import eu from '@/config/config.eu.json';
import staging from '@/config/config.staging.json';

export const watchers = [
  {
    getter: (state, rootState) => rootState.account.awsRegion,
    callback: ({ state, commit }, region) => {
      if (region) {
        // If we want to load dynamically:
        // import(`@/config/config.${window.devMode ? 'dev' : region.toLowerCase()}.json`)
        //   .then((config) => commit('config/load', config));

        // adding 'staging' as another awsRegion would require a lot of changes in project-manager
        // this is cheap and cheerful workaround until this is addressed
        if (
          Object.prototype.hasOwnProperty.call(state.account, 'isStaging') &&
          state.account.isStaging
        ) {
          commit('config/load', staging);
        } else {
          const env = window.devMode ? 'dev' : region.toLowerCase();
          commit('config/load', { dev, us, eu }[env]);
        }
      }
    },
  },
];

export default {
  namespaced: true,
  state: {
    socket: '',
    isReady: false,
  },
  mutations: {
    load(state, config) {
      Object.assign(state, config);
      state.isReady = true;
    },
  },
};
